export default __webpack_public_path__ + "static/media/marker-gray-blue-orange.acee339b.png";